import * as React from "react";
import type { SVGProps } from "react";
const SvgTimeline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#timeline_svg__a)">
      <path d="M12 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7m0-12C9.24 4 7 6.24 7 9s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5" />
      <path d="M13 11c-.26 0-.51-.1-.71-.29l-1-1A1 1 0 0 1 11 9V6c0-.55.45-1 1-1s1 .45 1 1v2.59l.71.71A.996.996 0 0 1 13 11M21 21H3c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1s-.45 1-1 1" />
      <path d="M19 22c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1M15 22c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1M11 22c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1M7 22c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1M3 22c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1" />
    </g>
    <defs>
      <clipPath id="timeline_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTimeline;
